import { TFunction } from "i18next";
import * as Yup from "yup";

import { nullableText } from "../../utils/validation.utils";
import { DonationsMaxLength } from "./DonationsView.types";
import { DONATION_QUESTIONS } from "./DonationsView.utils";

export function createDonationsSchema(t: TFunction) {
  return Yup.object().shape({
    answers: Yup.object().shape(
      Object.fromEntries(
        DONATION_QUESTIONS.map(({ detailsField }) => [detailsField, nullableText(t, DonationsMaxLength.details)])
      )
    ),
  });
}
